module.exports = __webpack_public_path__ + "static/media/illustration-trusted-device.15921533.svg";